import React, { useEffect } from "react";
import logoTransparent from "../assets/logo_transparent.png";
import { Link, useLocation } from "react-router";
import { MdClose, MdMenu } from "react-icons/md";
export default function MobileHeader({ setIsMenuOpen, isMenuOpen }) {
  const location = useLocation();
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <header className="sticky top-0 flex h-28 w-full items-center justify-between bg-white px-6 py-8 sm:px-8 md:px-10 lg:hidden"></header>
      <Link to="/" className="lg:hidden">
        <img
          src={logoTransparent}
          className="fixed left-6 top-8 z-50 h-12 sm:left-8 md:left-10"
          alt="access cv brand logo"
        />
      </Link>
      <button
        onClick={handleMenuClick}
        className="fixed right-6 top-10 z-50 flex items-center gap-2 sm:right-8 md:right-10 lg:hidden"
      >
        <h3 className="text-primaryColor">{isMenuOpen ? "Close" : "Menu"}</h3>
        {isMenuOpen ? (
          <MdClose className="text-3xl text-primaryColor" />
        ) : (
          <MdMenu className="text-3xl text-primaryColor" />
        )}
      </button>
    </>
  );
}
